export const state = () => ({
  activeTab: 'parcel', // 기본값, 'parcel', 'pickup', 'quick', 'bulk'
  currentDeliveryAddress: null, // 현재 선택된 배송지
  currentPickupStore: null // 현재 선택된 픽업매장
})

export const mutations = {
  SET_ACTIVE_TAB (state, tab) {
    state.activeTab = tab
  },
  SET_CURRENT_DELIVERY_ADDRESS (state, address) {
    state.currentDeliveryAddress = address
  },
  SET_CURRENT_PICKUP_STORE (state, store) {
    state.currentPickupStore = store
  }
}

export const actions = {
  updateActiveTab ({ commit }, tab) {
    commit('SET_ACTIVE_TAB', tab)
  },
  setCurrentDeliveryAddress ({ commit }, address) {
    commit('SET_CURRENT_DELIVERY_ADDRESS', address)
  },
  setCurrentPickupStore ({ commit }, store) {
    commit('SET_CURRENT_PICKUP_STORE', store)
  }
}

export const getters = {
  getActiveTab (state) {
    return state.activeTab
  },
  getCurrentDeliveryAddress (state) {
    return state.currentDeliveryAddress
  },
  getCurrentPickupStore (state) {
    return state.currentPickupStore
  }
}
